import React from 'react';
import { useRotaForm } from '../context/RotaContext';

const RotaFooter = () => {
  const { formData } = useRotaForm();

  const handleCreateRota = () => {
    console.log('Submitting entire state payload:', formData);
  };

  return (
    <div className="flex justify-between items-center border-t border-gray-200 pt-4 mt-8">
      <button type="button" className="text-sm font-medium text-gray-600 hover:text-gray-900">
        Cancel
      </button>
      <div className="flex gap-3">
        <button type="button" className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
          Save as Draft
        </button>
        <button 
          type="button" 
          onClick={handleCreateRota}
          className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition"
        >
          Create Rota
        </button>
      </div>
    </div>
  );
};

export default RotaFooter;
